import repeatservice from '@/http/services/repeatservice'
export default {
  getSummary ({ commit }) {
    return repeatservice.getSummary().then((summary) => {
      commit('setSummary',  summary.data)
    })
  },
  sendConfirmationEmail ({ commit }, data) {
    return repeatservice.sendConfirmationEmail(data).then((summary) => {
      return summary
    })
  },
}
